import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { SimpleChipItem } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const TriggerInput = styled(Flex)<{ $hasTagsAbove: boolean }>`
    align-items: center;
    gap: 12px;
    padding: 8px 10px;
    border: 1px solid ${colorsPalettes.midnight["50"]};
    border-radius: ${({ $hasTagsAbove }) => ($hasTagsAbove ? "0 0 3px 3px" : "3px")};
    cursor: text;
`;

export const ChipsWrapper = styled(Flex)`
    max-height: 88px;
    gap: 8px;
    flex-wrap: wrap;
    padding: 8px 12px;
    overflow: auto;
    border: 1px solid ${colorsPalettes.midnight["50"]};
    border-bottom: none;
    border-radius: 3px 3px 0 0;
`;

export const Chip = styled(SimpleChipItem)<{ $strikethrough?: boolean }>`
    margin: 0;
    ${({ $strikethrough }) => $strikethrough && "text-decoration: line-through;"}
`;
